import { Api } from './api';

export interface PlansResponse {
  id: string;
  name: string;
  highlight: string;
  originalMonthlyPrice: number;
  monthlyPrice: number;
  originalYearlyPrice: number;
  yearlyPrice: number;
  benefits: string[];
}

export interface Promo {
  code: string;
  description: string;
}

export async function GetCheckoutUrl(idPlanOffer: string, frequency: string) {
  const result = await Api.post<any, { id: string }>('/subscriptions/checkout', { idPlanOffer, frequency });
  return result;
}

export async function GetCustomerPortalUrl() {
  const result = await Api.get<any, { url: string }>('/subscriptions/portal');
  return result;
}

export async function GetPlans() {
  const result = await Api.get<any, PlansResponse[]>('/subscriptions/plans');
  return result;
}

export async function GetPromo() {
  const result = await Api.get<any, Promo | undefined>('/subscriptions/promo');
  return result;
}
